import { reactive, toRaw } from 'vue'
import head_p from '@/assets/img/chat/head_p.png'
import head_d from '@/assets/img/chat/head_d.png'
import head_a from '@/assets/img/chat/head_a.png' // BD的默认头像
import head_z from '@/assets/img/chat/head_z.png' // 医助默认头像
export default function useGroupOrder(info, ucUserId) {
  const avatarList = reactive([])
  const propsData = toRaw(info)
  if (propsData.groupName) {
    const avatarListcb = [head_p, head_d, head_a, head_z] // 默认头像
    const patientInfo = propsData ? propsData.patientInfo || {} : {}
    const doctorInfo = propsData ? propsData.doctorInfo || {} : {}
    const assistantInfos = propsData
      ? propsData.assistantInfos.find(item => !item.deleteFlag) || {}
      : {}
    //医助
    const doctorAssistantInfos = propsData
      ? propsData.doctorAssistantInfos.find(item => item.ucUserId == ucUserId) || {}
      : {}
    const infolist = [patientInfo, doctorInfo, assistantInfos, doctorAssistantInfos]
    infolist.map((item, index) => {
      if (JSON.stringify(item) !== '{}') {
        avatarList.push(item.headUrl || avatarListcb[index])
      }
    })
  }
  return {
    avatarList
  }
}
/**
 * @description: 计算当前工单属于那个会话
 * @return {string} id
 */
export function computeGroupId(
  guideConsultGroupId,
  groupId,
  doctorDaGroupId,
  assistantPatientGroupId,
  groupType
) {
  let id = ''
  if (groupType) {
    switch (groupType) {
      case 3:
        id = guideConsultGroupId
        break
      case 4:
        id = doctorDaGroupId
        break
      default:
        id = groupId || assistantPatientGroupId
        break
    }
  } else {
    // 导诊工单权重最高，其次群聊，最后私聊
    id = guideConsultGroupId || groupId || doctorDaGroupId || assistantPatientGroupId
  }
  return id
}
